import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from "react-router-dom";
import { useServices } from '../../hooks/useServices';

export const LoadPago = () => {

    const ref = useRef();
    const history = useHistory();

    const data = history.location.state;

    console.log('data recibida: ', data);
    const [licObjeto, setLicObjeto] = useState(data);
    const [loader, setLoader] = useState(true);
    const [urlCreate, setUrlCreate] = useState();

    const formEl = useRef();

    const reqLIC = {
        ...data
    }

    

    const { getCredenciales, getToken, guardaDataPay, getCODI} = useServices();

    

  async function verUrl(){
        const {value} = await getCODI(9);
      return value;
    }

	

  async function obtenerCredenciales(){
    const urlPagos = await verUrl();
    const {value} = await getCODI(6);//aqui se dice el canal segun el id en base: 5 att,  6 unefon, 12  ecommerce
    const myArray = value.split("|");
  
   
    const requestCredenciales = {
      "username": myArray[0],
      "channelId":19,//21 ecommerce , 18 att, 19 unefon
      "accessTokenId":myArray[1]
    }
  
    reqLIC.paymentSelfServiceRequest.channelId =19;
    setUrlCreate(urlPagos+'/pss/createPSSPayment');
    obtenerToken(requestCredenciales, urlPagos+'/pss/getTokenPPSS')
  }


    async function obtenerToken(payload, url){
      await getIP();
        const response = await getToken(payload, url);
          if (response) {
            setLoader(false);
            //console.log('token:', response);
            reqLIC.paymentSelfServiceRequest.token= "Bearer" + response.token;
            const strReqLIC = JSON.stringify(reqLIC);
            setLicObjeto(strReqLIC);
            
            setTimeout(()=>{gotoLIC()},4000);
            
          }else{
           // console.log('error al obtener token: ', response);
            history.push("/nopay", {noPago: true});
          }
    }

    const getIP = async() => {
      try {
        const response = await fetch('http://api.ipify.org/?format=json');
    
        if (!response.ok) {
          throw new Error(`Error! status: ${response.status}`);
        }
    
        const result = await response.json();
        reqLIC.paymentSelfServiceRequest.ipAddress = result.ip;
        //return result;
      } catch (err) {
        console.log(err);
      }
    }

    async function gotoLIC (){
      const extID = Number(licObjeto.paymentSelfServiceRequest.transactionExtId);
      const guarda = {
        "transactionExtId":extID,
        "statusId": 1
      }

    const respuestaBitacora = await guardaDataPay(guarda);
    //console.log('LIC : ', licObjeto);
    formEl.current.submit();
    }

   

    useEffect(() => {
        obtenerCredenciales();
        
    }, [data]);

  return (
      <>
    { loader 
        ? 
            <>
                <div className= "centered">
                <div className = "blob-1"></div>
                <div className = "blob-2"></div>
                
            </div>
            <div className="titulo">Conectando...</div>
            </>
        
        : <><div className= "centered">
                <div className = "blob-1"></div>
                <div className = "blob-2"></div>
                
            </div>
            <div className="tituloPago">Conectando servicios de pago...</div>
        
            <form ref={formEl} action={urlCreate} method="POST" >
              <input type="hidden" id="root" name="root" value={licObjeto}/>
            </form>
            </>
    }
     </>
   

  )
}
